import React, { useState } from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { ProductDetails } from '../components/ProductDetails';
import { Story } from '../components/Story';
import { Checkout } from '../components/Checkout';
import { Footer } from '../components/Footer';
import { PolicyModal } from '../components/PolicyModal';
import { PrivacyPolicy, RefundPolicy, ShippingPolicy } from '../components/PolicyContent';
type PolicyType = 'privacy' | 'refund' | 'shipping' | null;
export function CandleLandingPage() {
  const [quantity, setQuantity] = useState(1);
  const [openPolicy, setOpenPolicy] = useState<PolicyType>(null);
  const handleBuyNow = () => {
    const checkoutElement = document.getElementById('checkout');
    if (checkoutElement) {
      checkoutElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  const getPolicyContent = () => {
    switch (openPolicy) {
      case 'privacy':
        return {
          title: 'Privacy Policy',
          content: <PrivacyPolicy data-id="element-147" />
        };
      case 'refund':
        return {
          title: 'Refund & Returns Policy',
          content: <RefundPolicy data-id="element-148" />
        };
      case 'shipping':
        return {
          title: 'Shipping Policy',
          content: <ShippingPolicy data-id="element-149" />
        };
      default:
        return {
          title: '',
          content: null
        };
    }
  };
  const {
    title,
    content
  } = getPolicyContent();
  return <div className="min-h-screen bg-white" data-id="element-150">
      <Header data-id="element-151" />
      <main data-id="element-152">
        <Hero quantity={quantity} onQuantityChange={setQuantity} onBuyNow={handleBuyNow} data-id="element-153" />
        <ProductDetails data-id="element-154" />
        <Story data-id="element-155" />
        <Checkout quantity={quantity} onQuantityChange={setQuantity} data-id="element-156" />
      </main>
      <Footer onOpenPolicy={setOpenPolicy} data-id="element-157" />

      <PolicyModal isOpen={openPolicy !== null} onClose={() => setOpenPolicy(null)} title={title} data-id="element-158">
        {content}
      </PolicyModal>
    </div>;
}